import React from "react";
import { useInterviewContext } from "../InterviewContext";
import { useTranslation } from "react-i18next";
import "../../styles/forms.scss";
import Select from "../../../components/Select";

import SalaryPerLocationList from "../SalaryPerLocation/SalaryPerLocationList";

const SalarialCondition = () => {
  const { t } = useTranslation();
  const {
    interview,
    setInterview,
    errors,
    contractTypes,
    monetaryList
  } = useInterviewContext();

  const onChangeCurrentSalaryType = (event) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        currentSalaryValueIsLiquid:
          event.target.id === "currentSalaryValueIsLiquid" ? true : false
      }
    }));
  };

  const onChangeExpectedSalaryType = (event) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        salaryExpectedValueIsLiquid:
          event.target.id === "salaryExpectedValueIsLiquid" ? true : false
      }
    }));
  };

  const onChangeSalary = (event) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        [`${event.target.name}`]:
          event.target.value === "" ? 0 : Number(event.target.value)
      }
    }));
  };

  const onChangeAvailabilityAndConditions = ({ target }) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        [`${target.name}`]: Number(target.value)
      }
    }));
  };

  const onChangeAvailabilityAndConditionsSalarialInfo = ({ target }) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        [`${target.name}`]: target.value
      }
    }));
  };

  return (
    <form className="salary-condition">
      <h1>{t("Salarial Condition")}</h1>
      <div className="salary-info">
        <div className="form-group salary-width">
          <label htmlFor="currentSalary">{t("Current Salary")}</label>
          <input
            type="number"
            placeholder="0,00€"
            id="currentSalary"
            name="currentSalary"
            min={0}
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 10);
            }}
            onChange={onChangeSalary}
            value={interview.availabilityAndConditions.currentSalary}
          />
        </div>
        <div className="form-group type-contract-style">
          <label>{t("Currency")}</label>
          <Select
            id="currentSalaryCurrencyId"
            name="currentSalaryCurrencyId"
            className="form-select"
            onChange={onChangeAvailabilityAndConditions}
            value={
              interview.availabilityAndConditions.currentSalaryCurrencyId || 1
            }
            required
          >
            {monetaryList.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </Select>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="currentSalaryValueIsLiquid"
            id="currentSalaryValueIsLiquid"
            onChange={onChangeCurrentSalaryType}
            checked={
              interview.availabilityAndConditions.currentSalaryValueIsLiquid
            }
          />
          <label htmlFor="CurrentSalaryValueIsLiquid">{t("Liquid")}</label>
          <input
            className="form-check-input"
            type="radio"
            name="currentSalaryValueIsLiquid"
            id="currentSalaryValueIsNotLiquid"
            onChange={onChangeCurrentSalaryType}
            checked={
              !interview.availabilityAndConditions.currentSalaryValueIsLiquid
            }
          />
          <label htmlFor="currentSalaryValueIsNotLiquid">{t("Gross")}</label>
        </div>
        <div className="form-group type-contract-style">
          <label htmlFor="currentContract">{t("Current Contract")}</label>
          <Select
            id="currentContract"
            name="currentContract"
            onChange={onChangeAvailabilityAndConditions}
            value={interview.availabilityAndConditions.currentContract || 0}
            title={t("Selecione um item da lista.")}
            required
          >
            <option key={0} value={0} selected>
              {t("Select...")}
            </option>
            {contractTypes.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </Select>
        </div>
      </div>
      <div className="salary-info">
        <div className="form-group salary-width">
          <label>{t("Salary Expected*")}</label>
          {errors.salaryExpected && (
            <span className="error-msg-salary">{errors.salaryExpected}</span>
          )}
          <input
            type="number"
            placeholder="0,00€"
            id="salaryExpected"
            name="salaryExpected"
            onChange={onChangeSalary}
            min={0}
            onInput={(e) => {
              e.target.value = e.target.value.slice(0, 10);
            }}
            value={interview.availabilityAndConditions.salaryExpected || ""}
          />
        </div>

        <div className="form-group type-contract-style">
          <label>{t("Currency")}</label>
          <Select
            id="expectedSalaryCurrencyId"
            name="expectedSalaryCurrencyId"
            className="form-select"
            onChange={onChangeAvailabilityAndConditions}
            value={
              interview.availabilityAndConditions.expectedSalaryCurrencyId || 1
            }
            required
          >
            {monetaryList.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </Select>
        </div>

        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="salaryExpectedValueIsLiquid"
            id="salaryExpectedValueIsLiquid"
            onChange={onChangeExpectedSalaryType}
            checked={
              interview.availabilityAndConditions.salaryExpectedValueIsLiquid
            }
          />
          <label htmlFor="SalaryExpectedValueIsLiquid">{t("Liquid")}</label>
          <input
            className="form-check-input"
            type="radio"
            name="salaryExpectedValueIsLiquid"
            id="salaryExpectedValueIsNotLiquid"
            onChange={onChangeExpectedSalaryType}
            checked={
              !interview.availabilityAndConditions.salaryExpectedValueIsLiquid
            }
          />
          <label htmlFor="SalaryExpectedValueIsNotLiquid">{t("Gross")}</label>
        </div>
        <div className="form-group type-contract-style">
          <label htmlFor="desiredContractType">
            {t("Desired Contract Type")}
          </label>
          <Select
            id="expectedContract"
            name="expectedContract"
            className="form-select"
            onChange={onChangeAvailabilityAndConditions}
            value={interview.availabilityAndConditions.expectedContract || 0}
            required
            title={t("Selecione um item da lista.")}
          >
            <option key={0} value={0} selected>
              {t("Select...")}
            </option>
            {contractTypes.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.description)}
              </option>
            ))}
          </Select>
        </div>
      </div>
      <SalaryPerLocationList />
      <div className="form-group">
        <h1 htmlFor="SalarialInformation">{t("Salary Information")}</h1>
        <textarea
          rows="4"
          className="form-control"
          id="salarialInformation"
          name="salarialInformation"
          onChange={onChangeAvailabilityAndConditionsSalarialInfo}
          value={interview.availabilityAndConditions.salarialInformation}
          placeholder={t("Information about salary...")}
          maxLength={500}
        />
      </div>
    </form>
  );
};

export default SalarialCondition;
